import { supabase } from './supabase';

export interface PayrollSettings {
  id?: string;
  business_id: string;
  frequency: string;
  start_date: string;
  custom_period_1_start?: string;
  custom_period_1_end?: string;
  custom_period_2_start?: string;
  custom_period_2_end?: string;
  created_at?: string;
  updated_at?: string;
}

export async function savePayrollSettings(settings: PayrollSettings) {
  const { data, error } = await supabase
    .from('payroll_period_settings')
    .upsert({
      business_id: settings.business_id,
      period_type: settings.frequency,
      start_date: settings.start_date,
      custom_period_1_start: settings.custom_period_1_start,
      custom_period_1_end: settings.custom_period_1_end,
      custom_period_2_start: settings.custom_period_2_start,
      custom_period_2_end: settings.custom_period_2_end,
    }, {
      onConflict: 'business_id',
      ignoreDuplicates: false
    });

  if (error) {
    throw new Error(`Error saving payroll settings: ${error.message}`);
  }

  return data;
}

export async function getPayrollSettings(businessId: string): Promise<PayrollSettings | null> {
  const { data, error } = await supabase
    .from('payroll_period_settings')
    .select('*')
    .eq('business_id', businessId)
    .single();

  if (error) {
    if (error.code === 'PGRST116') { // No rows returned
      return null;
    }
    throw new Error(`Error loading payroll settings: ${error.message}`);
  }

  if (!data) return null;

  return {
    id: data.id,
    business_id: data.business_id,
    frequency: data.period_type,
    start_date: data.start_date,
    custom_period_1_start: data.custom_period_1_start,
    custom_period_1_end: data.custom_period_1_end,
    custom_period_2_start: data.custom_period_2_start,
    custom_period_2_end: data.custom_period_2_end,
    created_at: data.created_at,
    updated_at: data.updated_at
  };
} 